export class ExternalComment {
  comment: string;
  updateUserName: string;
  updateDateTime: Date;
}
